const state = {

    refresh_key: 0,
    
    // TRANSACTION
    transaction_id: null,
    transaction_settings_id: null,
    transactionIndexDialog: false,
    transactionNotesDialog: false,
    transactionProcessDialog: false,
    transactionSettingsDetailDialog: false,

    vault_card_id: null,
    vault_ach_id: null,
    terminalTokenCardDetailDialog: false,
    terminalTokenAchDetailDialog: false,

    terminalPaymentTypeTabsDialog: false,

    header: true,
    titlebar: false,

    labels: {},

};

const getters = {};

const mutations = {};

const actions = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
